export async function showToast(message, completionCallback, duration = 2000) 
{
  const toast = document.createElement('ion-toast');
  toast.message = message;
  toast.duration = duration;
  
  document.body.appendChild(toast);
  
  await toast.present();
  await toast.onDidDismiss();

  if (completionCallback)
    completionCallback();
}